import { Axios } from '../axios'

//For Mobile
const getEmployeeByTeam = async (payload) => {
  const { data } = await Axios.get(
    `/mobile/performances/by-source/team/${payload.id}`,
    payload
  )
  return data
}

const fetchRegistration = async (payload) => {
  const { data } = await Axios.get(
    '/mobile/companies/employee-register',
    payload
  )
  return data
}

const fetchEmployeeInformation = async (payload) => {
  const { data } = await Axios.get(
    '/mobile/companies/employee-infromation',
    payload
  )
  return data?.data
}

const updateEmployeeProfile = async (payload) => {
  const { data } = await Axios.put('/mobile/profile-update-request', payload)
  return data
}

const employeeUploadProfilePicture = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/employee/upload-profile-photo',
    payload
  )
  return data
}

const updateInvitedEmployee = async (payload) => {
  const { data } = await Axios.post(
    '/mobile/companies/save-employee-details',
    payload.data
  )
  return data
}

const updateEmployeeBank = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/employees/update-bank/' + payload.employeeId,
    payload.data
  )
  return data
}

const updateEmployee = async (payload) => {
  const { data } = await Axios.put(
    '/mobile/employees/' + payload.employeeId,
    payload.data
  )
  return data
}

const getEmployeeById = async (payload) => {
  const { data } = await Axios.get('/mobile/employees/' + payload)
  return data?.data
}

const getEmployees = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : ''
  let country = payload.country ? '&country=' + payload.country : ''

  let filter =
    payload.statusFilter && payload.statusFilter != -1
      ? '&filter=' + payload.statusFilter
      : ''

  const { data } = await Axios.get(
    `mobile/employees?limit=${payload.limit}&page=${payload.page}${filter}${search}${country}`,
    {
      timeout: 0,
    }
  )

  return data?.data
}

export const employees = {
  fetchRegistration,
  fetchEmployeeInformation,
  employeeUploadProfilePicture,
  updateInvitedEmployee,
  getEmployeeByTeam,
  updateEmployeeProfile,
  updateEmployeeBank,
  updateEmployee,
  getEmployeeById,
  getEmployees,
}
